import { useGet } from "../../hooks/useGet";
import { NftsOverview, Spinner } from "../../components";
import React from "react";
import "./index.scss";
export var NftsOverviewLazy = function NftsOverviewLazy() {
  var _useGet = useGet("/nfts/lazy"),
      data = _useGet.data;

  return (data === null || data === void 0 ? void 0 : data.nfts) ? /*#__PURE__*/React.createElement(NftsOverview, {
    nfts: data.nfts,
    lazy: true,
    title: "NFTs Created"
  }) : /*#__PURE__*/React.createElement(Spinner, null);
};